export default "__VITE_ASSET__55BApUgP__"